import {
    type FC
} from "react";
import type IPopoverSurfaceHeadingProps from "./type";
import stylesheet, {
    POPOVER_SURFACE_HEADING_VARIANT,
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import Text from "../../../text";

const PopoverSurfaceHeading: FC<IPopoverSurfaceHeadingProps> = ({
    variant = "popover",
    customTheme,
    children,
    style,
    ...props
}) => {
    const {
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        heading: headingDynamicStyle
    } = useStyles({
        variant,
        spaces
    });

    return <Text
        {...props}
        variant={POPOVER_SURFACE_HEADING_VARIANT}
        customTheme={customTheme}
        style={[
            style,
            stylesheet.heading,
            headingDynamicStyle
        ]}
        color="low"
    >
        {children}
    </Text>;
};
export default PopoverSurfaceHeading;
